import type { SWRConfiguration, SWRResponse } from 'swr';
import useSWR from 'swr';

import { MagicUser } from './magic-link/type';

const fetcher = (url: string): Promise<{ user?: MagicUser }> =>
  fetch(url)
    .then((r) => r.json())
    .then((data) => {
      return { user: data?.user ?? undefined };
    });

function useUser(
  userApiUrl = '/api/user',
  options?: SWRConfiguration,
): SWRResponse<{ user?: MagicUser }, Error> {
  return useSWR(userApiUrl, fetcher, options);
}

export default useUser;
